import React, { useEffect } from "react";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";

import { getSessionUser } from "../../../services/sessionService";
import { clearClientSession } from "../../../services/session";
import { GarageProvider } from "../../../garage/GarageContext";
import GarageShell from "../../../garage/GarageShell";
import GaragePage from "../../../garage/GaragePage";
import HistoryPage from "../../../garage/HistoryPage";
import VehiclesPage from "../../../garage/VehiclesPage";
import DocumentsPage from "../../../garage/DocumentsPage";
import NewVehicle from "./pages/vehicles/newVehicle";
import Profile from "./pages/profile/Profile";
import ConfirmationData from "../../../pages/confirmationData/ConfirmationData";

// Area do cliente ("Minha garagem"): uma moldura so, responsiva, para celular e desktop.
function Client({ history }) {

    useEffect(() => {
        let active = true;
        const checkSession = async () => {
            let user = null;
            try {
                user = await getSessionUser();
            } catch (err) {
                // sem resposta da API a sessao nao pode ser confirmada
            }
            if (!active) return;
            if (!user) {
                clearClientSession()
                history.push('/client/login')
                return;
            }
            localStorage.setItem('NOME_USUARIO', user.name);
            // Visualizacao do suporte (so leitura): nada a confirmar nem a gravar.
            if (user.readOnly) return;
            const isUserConfirmed = localStorage.getItem('USER_CONFIRMED');
            if(!isUserConfirmed || isUserConfirmed !== 'true') {
                history.push('/client/confirmation-data');
            }
        };
        checkSession();
        return () => { active = false };
    }, [history])

    return (
        <GarageProvider>
            <GarageShell>
                <Switch>
                    <Route path="/client/dashboard" component={GaragePage} />
                    <Route path="/client/maintances" component={HistoryPage} />
                    <Route path="/client/vehicles" component={VehiclesPage} />
                    <Route path="/client/documents" component={DocumentsPage} />
                    <Route path="/client/newvehicle" component={NewVehicle} />
                    <Route path="/client/profile" component={Profile} />
                    <Route path="/client/confirmation-data" component={ConfirmationData} />
                    <Redirect to="/client/dashboard" />
                </Switch>
            </GarageShell>
        </GarageProvider>
    );
}

export default withRouter(Client)
